import { useState, useEffect } from 'react';

import { useGetMultiCatchColumns } from './useGetMultiCatchColumns';
import MultiCatchExpandable from './MultiCatchExpandable';

import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useGetSmartMultiTraps from 'hooks/Traps/useGetSmartMultiTraps';
import { MultiCatchTrapData } from 'api/traps/types';
import useScreenSize from 'hooks/Screen/useScreenSize';
import TrapDeleteModal from 'components/DeleteTrapModal/TrapsDeleteModal';
import ManageTrapModal from 'pages/Traps/Modals/AddTrapModal/ManageTrapModal';
import EditTrapModal from 'pages/Traps/Modals/EditTrapModalStore/EditTrapModal';

interface TableProps {
  slug: string;
}

const MultiCatchMouseTrapsTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetSmartMultiTraps(slug || '');
  const columns = useGetMultiCatchColumns(slug);
  const { isNotDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white">
      <FilterDataTable<MultiCatchTrapData>
        columns={columns}
        data={data || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotDesktop}
        expandableRowsComponent={row => <MultiCatchExpandable data={row.data} slug={slug} />}
      />
      <TrapDeleteModal refetchTraps={refetch} />
      <ManageTrapModal refetchTraps={refetch} />
      <EditTrapModal refetchTraps={refetch} />
    </div>
  );
};

export default MultiCatchMouseTrapsTable;
